module.exports = __webpack_public_path__ + "pt.svg?6143c8e6835f2dba4080dd2214db7b3f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/pt.svg
// module id = 1322
// module chunks = 0